import { useMemo, useState } from "preact/hooks";
import { useLocation, useSearch } from "wouter-preact";
import { normalizeCustomerAccountCode, normalizeInvoiceReferenceCode } from "../lib/lookupCode";
import { routes } from "../lib/route";

export function SearchPage() {
  const [, navigate] = useLocation();
  const search = useSearch();
  const query = useMemo(() => new URLSearchParams(search), [search]);
  const [invoiceCode, setInvoiceCode] = useState("");
  const [accountCode, setAccountCode] = useState("");
  const [invoiceError, setInvoiceError] = useState(query.get("invoiceError"));
  const [accountError, setAccountError] = useState(query.get("accountError"));

  function submitInvoice(event: Event) {
    event.preventDefault();
    const code = normalizeInvoiceReferenceCode(invoiceCode);
    if (!code) {
      setInvoiceError("Enter an invoice number.");
      return;
    }

    navigate(routes.invoice(code));
  }

  function submitAccount(event: Event) {
    event.preventDefault();
    const code = normalizeCustomerAccountCode(accountCode);
    if (!code) {
      setAccountError("Enter an account code.");
      return;
    }

    navigate(routes.accountDetail(code));
  }

  return (
    <section class="search-page" aria-label="Payment lookup">
      <div class="search-heading">
        <h2>What would you like to pay?</h2>
      </div>

      <div class="search-options">
        <form class="search-card" onSubmit={submitInvoice}>
          <div>
            <h3>Pay an invoice</h3>
            <p class="muted">Use the invoice number printed on your invoice.</p>
          </div>

          <label class="form-control">
            <span>Invoice number</span>
            <input
              value={invoiceCode}
              placeholder="INV-123"
              aria-invalid={invoiceError != null}
              aria-describedby={invoiceError != null ? "invoice-code-error" : undefined}
              onInput={(event) => {
                setInvoiceCode(event.currentTarget.value);
                setInvoiceError(null);
              }}
            />
          </label>

          {invoiceError && (
            <p id="invoice-code-error" class="payment-error" role="alert">
              {invoiceError}
            </p>
          )}

          <button class="primary-action" type="submit">
            Look up invoice
          </button>
        </form>

        <form class="search-card" onSubmit={submitAccount}>
          <div>
            <h3>Pay account balance</h3>
            <p class="muted">Use the account code from your statement.</p>
          </div>

          <label class="form-control">
            <span>Account code</span>
            <input
              value={accountCode}
              placeholder="ABCZYX"
              aria-invalid={accountError != null}
              aria-describedby={accountError != null ? "account-code-error" : undefined}
              onInput={(event) => {
                setAccountCode(event.currentTarget.value);
                setAccountError(null);
              }}
            />
          </label>

          {accountError && (
            <p id="account-code-error" class="payment-error" role="alert">
              {accountError}
            </p>
          )}

          <button class="primary-action" type="submit">
            Look up account
          </button>
        </form>
      </div>
    </section>
  );
}
